export const categories = [
  { id: 'mingxing-bagua', name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', description: '娱乐圈最新明星动态、恋情曝光、综艺幕后' },
  { id: 'wanghong-baoliao', name: '网红爆料', slug: 'wanghong-baoliao', icon: 'ri-live-line', description: '网红圈最新爆料、直播翻车、人设崩塌' },
  { id: 'shehui-redian', name: '社会热点', slug: 'shehui-redian', icon: 'ri-fire-line', description: '社会事件深度扒皮、热点话题追踪' },
  { id: 'yule-zongyi', name: '娱乐综艺', slug: 'yule-zongyi', icon: 'ri-tv-line', description: '综艺节目名场面、选手八卦、幕后故事' },
  { id: 'dianshi-juqing', name: '影视剧情', slug: 'dianshi-juqing', icon: 'ri-film-line', description: '热门剧集深度解读、演员片场趣闻' },
  { id: 'heike-liao', name: '黑料实锤', slug: 'heike-liao', icon: 'ri-alert-line', description: '实锤黑料汇总、造假翻车现场' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时',
    slug: 'dingliu-nanxing-shenye-mihui',
    excerpt: '据知情人士爆料，某一线男星近日被拍到与一名神秘女子深夜进出某五星级酒店，两人举止亲密，引发网友热议。',
    content: `【独家爆料】近日，有网友在某五星级酒店门口拍到一组令人震惊的画面。\n\n据目击者描述，当晚11点左右，一辆黑色商务车缓缓驶入酒店地下车库。从车上下来的，正是近期热度极高的某顶流男星。与他同行的还有一名身着黑色连衣裙的神秘女子，两人全程保持亲密距离。\n\n更让人浮想联翩的是，两人直到第二天早上7点才先后离开酒店。虽然刻意错开了出门时间，但还是被蹲守的粉丝拍了个正着。\n\n该男星的经纪团队目前尚未对此事做出任何回应。但网络上已经炸开了锅，相关话题迅速登上热搜榜首位。有粉丝表示"等待官方回应"，也有网友调侃"这是要塌房的节奏吗"。\n\n我们持续关注此事后续发展。`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20lighting%20and%20a%20black%20luxury%20car%20parked%20in%20front%20mysterious%20atmosphere%20paparazzi%20style%20photography%20warm%20amber%20street%20lights%20reflecting%20on%20wet%20pavement%20cinematic%20composition%20with%20shallow%20depth%20of%20field%20urban%20night%20scene%20high%20contrast%20shadows&width=800&height=450&seq=article-dingliu-01&orientation=landscape',
    tags: ['顶流', '恋情曝光', '酒店密会'],
    isHot: true,
    isTop: true,
    date: '2026-07-06',
    views: 1258000,
  },
  {
    id: 2,
    title: '知名带货主播翻车！被曝售卖假货，直播间当场被抓包',
    slug: 'zhiming-daihuo-fanche',
    excerpt: '拥有千万粉丝的带货主播在最新一场直播中被消费者当场指认售卖假冒品牌化妆品，品牌官方火速发声明否认授权。',
    content: `【重磅】昨晚的一场直播带货中，拥有超过2000万粉丝的头部主播"XX严选"遭遇了职业生涯最大的翻车现场。\n\n直播进行到一半时，主播正在热情推销一款声称"专柜正品、假一赔十"的国际大牌面霜。突然，有消费者在弹幕中晒出品牌官方客服的回复截图，明确指出该主播并未获得该品牌的任何销售授权。\n\n一时间，弹幕炸开了锅。"假货"、"退钱"的评论刷屏。主播当场脸色大变，匆忙下播。\n\n事后品牌方官方微博火速发布声明：从未授权任何直播渠道销售该产品，提醒消费者通过正规渠道购买。目前该主播的账号已被平台暂时封禁，相关部门也已介入调查。\n\n这已经不是直播带货行业第一次出现假货风波了。消费者权益保护组织呼吁平台加强审核机制，建立更严格的带货准入门槛。`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20livestream%20selling%20scene%20with%20a%20shocked%20streamer%20in%20front%20of%20ring%20lights%20and%20product%20displays%20chaotic%20atmosphere%20with%20red%20alert%20notifications%20on%20screen%20modern%20streaming%20studio%20setup%20tension%20and%20drama%20news%20style%20documentary%20photography%20warm%20studio%20lighting%20with%20harsh%20shadows&width=600&height=340&seq=article-daihuo-02&orientation=landscape',
    tags: ['直播带货', '假货', '翻车现场'],
    isHot: true,
    isTop: false,
    date: '2026-07-06',
    views: 987000,
  },
  {
    id: 3,
    title: '某女团成员被曝与经纪公司闹解约，天价违约金曝光',
    slug: 'nvtuan-jieyue-fengbo',
    excerpt: '当红女团人气成员因长期遭受不公平待遇，已向法院提起诉讼要求解除合约，违约金数字惊人引发行业震动。',
    content: `【深度追踪】据可靠消息，某当红女团的人气成员已于上月向首尔中央地方法院提起了专属合约效力中止的诉讼申请。\n\n知情人士透露，该成员自出道以来长期承受超负荷工作安排，每周工作时间超过80小时，且收入分配极不合理——个人实际到手仅占总收入的5%。更令人震惊的是，合约中约定的违约金高达50亿韩元（约合人民币2700万元）。\n\n此事在韩国娱乐圈引发轩然大波。多位已解约的前辈艺人公开声援，呼吁行业改革。粉丝们也发起了大规模的线上请愿活动，目前已收集超过50万个签名。\n\n法律专家分析认为，该案件可能成为韩国偶像产业合约改革的标志性案例。我们将持续关注案件进展。`,
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20courtroom%20scene%20with%20legal%20documents%20scattered%20on%20a%20polished%20wooden%20table%20gavel%20in%20the%20background%20soft%20natural%20window%20light%20creating%20dramatic%20shadows%20serious%20and%20tense%20atmosphere%20editorial%20photography%20style%20warm%20tones%20with%20deep%20contrasts&width=600&height=340&seq=article-nvtuan-03&orientation=landscape',
    tags: ['女团', '解约', '违约金'],
    isHot: true,
    isTop: false,
    date: '2026-07-05',
    views: 756000,
  },
  {
    id: 4,
    title: '某知名导演被多人实名举报，圈内人士集体沉默',
    slug: 'zhiming-daoyan-beiju',
    excerpt: '短短三天内已有四位圈内人士实名举报某知名导演存在不当行为，但截至目前无任何明星公开表态。',
    content: `【持续关注】娱乐圈再掀波澜。自7月3日第一位举报人站出来后，截至发稿前已有四位圈内人士通过社交媒体实名举报某知名导演。\n\n举报内容涉及职场霸凌、财务侵占等多方面问题。举报人均提供了详细的聊天记录和转账凭证作为证据。然而令人玩味的是，与该导演合作过的众多一线明星至今集体保持沉默。\n\n有媒体尝试联系多位艺人经纪团队，均以"不方便回应"为由拒绝采访。\n\n网友对此反应两极分化。有人表示"墙倒众人推"，也有人认为"沉默就是最大的纵容"。目前相关监管部门表示已经关注到此事，将依法依规处理。\n\n这一事件的发展令人深思：娱乐圈的潜规则到底还有多少？`,
    category: '黑料实锤',
    categorySlug: 'heike-liao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20film%20set%20with%20a%20director%20chair%20empty%20in%20the%20foreground%20clapperboard%20on%20the%20ground%20moody%20atmosphere%20with%20dramatic%20side%20lighting%20creating%20long%20shadows%20cinematic%20noir%20style%20tension%20and%20silence%20film%20equipment%20scattered%20around%20warm%20amber%20key%20light%20with%20deep%20blue%20shadows&width=600&height=340&seq=article-daoyan-04&orientation=landscape',
    tags: ['导演', '实名举报', '圈内沉默'],
    isHot: false,
    isTop: false,
    date: '2026-07-05',
    views: 632000,
  },
  {
    id: 5,
    title: '综艺录制现场突发意外，选手受伤节目组被骂上热搜',
    slug: 'zongyi-luzhi-yiwai',
    excerpt: '某热门选秀综艺录制过程中，因舞台设备故障导致一名选手从两米高台坠落，节目组应急处理引发争议。',
    content: `【热点追踪】昨天下午，某热门选秀综艺在录制过程中发生了令人揪心的意外。\n\n据现场观众描述，当时正在进行一场高难度的舞台表演环节。一名选手在完成空中翻转动作时，威亚设备突然出现故障，导致该选手从约两米高的位置坠落。现场一片惊呼。\n\n更令人愤怒的是，事故发生后节目组的第一反应不是呼叫医疗救助，而是要求现场观众删除手机中的拍摄视频。这一行为被观众曝光后，迅速登上热搜。\n\n所幸该选手经医院检查后确认无生命危险，但脚踝骨折需要至少三个月恢复。节目组在舆论压力下终于发布道歉声明，但网友并不买账，纷纷要求追责相关人员。\n\n这次事件再次引发了公众对综艺节目安全问题的关注。`,
    category: '娱乐综艺',
    categorySlug: 'yule-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20television%20studio%20stage%20with%20spotlight%20beams%20cutting%20through%20haze%20empty%20performance%20area%20with%20fallen%20equipment%20visible%20backstage%20chaos%20atmosphere%20warm%20stage%20lights%20creating%20dramatic%20contrast%20documentary%20style%20behind%20the%20scenes%20photography%20tension%20and%20urgency%20in%20the%20air&width=600&height=340&seq=article-zongyi-05&orientation=landscape',
    tags: ['综艺', '安全事故', '选手受伤'],
    isHot: true,
    isTop: false,
    date: '2026-07-04',
    views: 889000,
  },
  {
    id: 6,
    title: '某富豪之子深夜飙车被拘，现场视频全网疯传',
    slug: 'fuhao-zhi-zi-biaoche',
    excerpt: '某知名企业家之子驾驶限量版超跑在市区道路飙车，时速超200公里被交警当场截停，豪车被扣。',
    content: `【社会热点】今天凌晨2点左右，某市交警在市区主干道拦截了一辆严重超速的限量版布加迪超跑。\n\n经查，驾驶员为某知名企业家之子，年仅22岁。该车辆在限速60公里的市区道路上，实测时速高达213公里/小时，超速幅度惊人。交警在其车内还发现了疑似改装过的排气管和ECU芯片。\n\n现场执法视频被路人拍摄并上传至网络后，播放量在短短几小时内突破千万。"有钱就可以为所欲为吗"成为热门评论。\n\n目前该驾驶员因涉嫌危险驾驶罪已被依法刑事拘留，涉案车辆被暂扣。律师表示，根据相关法律，该驾驶员可能面临6个月以下拘役及吊销驾驶证的处罚。\n\n此事也引发了社会对"富二代"群体的广泛讨论。`,
    category: '社会热点',
    categorySlug: 'shehui-redian',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20supercar%20pulled%20over%20by%20police%20at%20night%20on%20a%20city%20street%20police%20lights%20flashing%20red%20and%20blue%20reflecting%20off%20the%20car%20body%20dramatic%20night%20scene%20with%20wet%20road%20surface%20urban%20backdrop%20with%20skyscrapers%20documentary%20news%20photography%20style%20tense%20atmosphere%20cinematic%20lighting&width=600&height=340&seq=article-biaoche-06&orientation=landscape',
    tags: ['富二代', '飙车', '危险驾驶'],
    isHot: false,
    isTop: false,
    date: '2026-07-04',
    views: 1102000,
  },
  {
    id: 7,
    title: '热播剧男女主被曝戏外不和，片场零交流实锤',
    slug: 'reboju-nannvzhu-buhe',
    excerpt: '某收视冠军剧集的男女主角被爆料在片场几乎零交流，疑似因番位之争关系降至冰点，第二季合作存疑。',
    content: `【剧组八卦】正在热播的某古装大剧创下了今年收视新高，但戏里的甜蜜CP在戏外却是另一番景象。\n\n据剧组工作人员匿名爆料，男女主角在拍摄后期几乎没有任何私下交流。除了必要的对戏外，两人各自待在房车内，连剧组聚餐都是分开坐。一位不愿透露姓名的场记表示："气氛真的很尴尬，大家都感觉到了。"\n\n坊间传闻两人的矛盾源于番位之争。该剧最初宣发时是平番，但随着剧情发展女主戏份明显增多，引起了男主团队的不满。有消息称男主团队曾向制片方施压要求调整剧本。\n\n目前第二季已经提上日程，但两位主演是否回归尚无定论。粉丝们在社交媒体上已经吵得不可开交。`,
    category: '影视剧情',
    categorySlug: 'dianshi-juqing',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20film%20set%20behind%20the%20scenes%20with%20two%20empty%20chairs%20facing%20away%20from%20each%20other%20clapperboard%20and%20scripts%20on%20a%20table%20between%20them%20tension%20in%20the%20air%20soft%20cinematic%20lighting%20with%20warm%20tones%20film%20production%20equipment%20in%20background%20editorial%20documentary%20style%20quiet%20drama%20and%20unspoken%20conflict&width=600&height=340&seq=article-juqing-07&orientation=landscape',
    tags: ['热播剧', '番位之争', '戏外不和'],
    isHot: false,
    isTop: false,
    date: '2026-07-03',
    views: 543000,
  },
  {
    id: 8,
    title: '网红餐厅后厨曝光：老鼠乱窜、食材过期仍在使用',
    slug: 'wanghong-canting-houchu',
    excerpt: '拥有百万粉丝的美食探店博主暗访某网红餐厅后厨，拍摄到的画面令人作呕，市监局已介入调查。',
    content: `【触目惊心】一位拥有200万粉丝的美食博主近日对该市最火的网红餐厅进行了暗访调查，结果令人震惊。\n\n暗访画面显示，该餐厅后厨卫生状况极其糟糕：地面上污水横流，墙角有老鼠肆无忌惮地穿行，操作台上爬满了蟑螂。更可怕的是，冰箱内存放的多种食材已经明显过期，有的甚至已经发霉变质，但厨师仍然照常使用。\n\n该视频发布后，播放量迅速突破2000万。大量在该餐厅消费过的网友纷纷留言表示"想吐"、"怪不得上次吃完拉肚子"。\n\n当地市场监督管理局已连夜对该餐厅进行突击检查，当场查封了所有过期食材，并责令停业整顿。餐厅老板被带走配合调查。据悉，该餐厅面临至少50万元的行政处罚。\n\n这个事件再次提醒我们：网红店的背后，不一定是美味，也可能是黑暗料理。`,
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dirty%20restaurant%20kitchen%20with%20dim%20fluorescent%20lighting%20messy%20countertops%20with%20scattered%20ingredients%20health%20inspection%20atmosphere%20documentary%20undercover%20photography%20style%20gritty%20realism%20harsh%20overhead%20lighting%20creating%20stark%20shadows%20journalistic%20exposure%20mood&width=600&height=340&seq=article-canting-08&orientation=landscape',
    tags: ['网红餐厅', '食品安全', '暗访'],
    isHot: true,
    isTop: false,
    date: '2026-07-03',
    views: 1456000,
  },
];

export const trendingTags = ['顶流塌房', '直播翻车', '恋情曝光', '解约风波', '综艺翻车', '富二代', '食品安全'];